import React from "react";
import logo from 'assets/img/ic-logo.png';
import './Header.scss'

export const Header: React.FC = () => {
  // const [msg, setMsg] = React.useState('');
  // useEffect(() => {
  //   (window as any).messageFromApp = (d: any) => {
  //     alert(d)
  //     // setMsg(d);
  //   }
  //   window.addEventListener('message', function(event: any) {
  //     const message = event.data;
  //     setMsg('from app ' + JSON.stringify(message));
  //     console.log('Received message from iOS app:', message);
  //     // alert('Received from app: ' + message);
  // });
  // }, []);
  return (
    <div className="app-header navbar sticky-top">
      <div className="container">
      <div className="app-brand">
        <img src={logo} alt="" onClick={() => {
          // const data: any = { oppcToken: 'fdsafdsa' };
          (window as any).webkit.messageHandlers.nativeApiHandler.postMessage("appLogout");

        // (window as any).webkit.messageHandlers.getMessenger.postMessage(data);
    // window.postMessage({ type: "OPEN_HOME" }, "*");
        }} />
        <span>Private Gallery</span>
      </div>
      </div>
      
    </div>
  )
}